<template>
  <section style="margin:auto; max-width:900px">
    <div class="card-group" style="width:80%;margin-top:20px; margin-left:10%; border-radius:15px">
      <div class="card" style="text-align:center">
        <img
          src="public/images/site/inmersivo.svg"
          id="challenges"
          alt="Inmersivo"
          style="width:200px"
        />
        <h5>Inmersivo</h5>
        <p>Los chicos pasan de ser espectadores a protagonistas</p>
      </div>

      <div class="card" style="text-align:center">
        <img
          src="public/images/site/calidad.svg"
          id="challenges"
          alt="Inmersivo"
          style="width:200px"
        />
        <h5>Calidad</h5>
        <p>El contenido y la experiencia de aprendizaje es la base de todo lo que hacemos.</p>
      </div>

      <div class="card" style="text-align:center">
        <img src="public/images/site/seguro.svg" id="challenges" alt="Seguro" style="width:200px" />
        <h5>Seguro</h5>
        <p>El aprendizaje de los chicos se da en un espacio protegido. Sin bullies, sin mayores.</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app",

  data() {
    return {
      errorMessage: "",
      login: {
        usuario: "",
        password: ""
      }
    };
  },

  computed: {
    ...mapGetters(["pathAPI", "userLogged"])
  },

  methods: {},

  computed: {},
  components: {},

  mounted: function() {}
};
</script>

<style scoped>
.card {
  max-width: 300px;
  text-align: center;
  align-items: center;
  padding: 10px;
  margin: 20px;
  border: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/BenefitsBanner.vue